<template>
  <form
    autocomplete="off"
    class="employee-creation"
    v-on:submit.prevent="onSubmit"
  >
    <p
      v-if="isBranch"
      class="employee-creation__status-title">
      Редактирование основной информации недоступно.
      Внесение изменений возможно только в основном филиале трудоустройства сотрудника
    </p>
    <div class="employee-creation__row">
      <label
        class="employee-creation__group"
        v-bind:class="{ field_error: surnameInputErrors.length > 0 }"
      >
        <span class="employee-creation__label">Фамилия</span>
        <input
          v-bind:disabled="isBranch"
          class="employee-creation__input"
          placeholder=""
          type="text"
          v-model="surname"
          v-letter-capital />
        <p
          class="employee-creation__error-text"
          role="alert"
          v-bind:key="id"
          v-for="(text, id) in surnameInputErrors"
        >{{ text }}</p>
      </label>
      <label
        class="employee-creation__group"
        v-bind:class="{ field_error: nameInputErrors.length > 0 }"
      >
        <span class="employee-creation__label">Имя</span>
        <input
          v-bind:disabled="isBranch"
          class="employee-creation__input"
          placeholder=""
          type="text"
          v-model="name"
          v-letter-capital />
        <p
          class="employee-creation__error-text"
          role="alert"
          v-bind:key="id"
          v-for="(text, id) in nameInputErrors"
        >{{ text }}</p>
      </label>
      <label
        class="employee-creation__group"
        v-bind:class="{ field_error: patronymicInputErrors.length > 0 }"
      >
        <span class="employee-creation__label">Отчество</span>
        <input
          v-bind:disabled="isBranch"
          class="employee-creation__input"
          placeholder=""
          type="text"
          v-model="patronymic"
          v-letter-capital />
        <p
          class="employee-creation__error-text"
          role="alert"
          v-bind:key="id"
          v-for="(text, id) in patronymicInputErrors"
        >{{ text }}</p>
      </label>
    </div>
    <div>
      <the-select
        v-bind:disabled="isBranch"
        class="employee-creation__multiline"
        title="Выберите роль"
        v-bind:options="employeeRoleList"
        v-bind:value="roleId"
        v-bind:violations="roleIdInputErrors"
        v-on:input="onInputRole"
      />
    </div>
    <label
      class="employee-creation__group"
      v-if="isDoctor"
    >
      <span class="employee-creation__label">Укажите специализацию</span>
      <input
        v-bind:disabled="isBranch"
        class="employee-creation__input"
        placeholder=""
        type="text"
        v-model="specialtyName"
        v-letter-capital />
    </label>
    <div
      class="employee-creation__contacts"
      v-bind:class="{ align: phoneNumberInputErrors.length > 0 }">
      <input-phone
        v-bind:disabled="isBranch"
        v-bind:violations="phoneNumberInputErrors"
        v-model="phoneNumber" />
      <div class="employee-creation__contact__row">
        <label class="employee-creation__contact whats-app">
          <input
            v-bind:disabled="isBranch"
            type="checkbox"
            v-model="hasWhatsappByPhone" />
          <span>WhatsApp</span>
        </label>
        <label class="employee-creation__contact telegram">
          <input
            v-bind:disabled="isBranch"
            type="checkbox"
            v-model="hasTelegramByPhone" />
          <span>Telegram</span>
        </label>
      </div>
    </div>
    <collapse-button
      caption="Дополнительно"
      v-bind:value="isOpenOptionalSection || !this.isEdit"
      v-on:input="onCollapseOptionalSection"
    >
      <template>
        <div class="employee-creation__collapse indent">
          <div class="employee-creation__row">
            <input-inn
              v-bind:disabled="isBranch"
              v-bind:violations="innInputErrors"
              v-bind:optional="true"
              v-model="inn"
            />
            <input-date
              v-bind:disabled="isBranch"
              label="Дата рождения"
              v-bind:violations="birthDateInputErrors"
              v-model="birthDate" />
          </div>

          <div class="employee-creation__checkboxes">
            <template v-if="!isDismissed">
              <input-checkbox
                v-if="!isAdmin"
                title="Выводить в расписании"
                v-model="isEnabledWorkingScheduling" />
              <input-checkbox
                v-if="!isAdmin && isEnabledWorkingScheduling"
                title="Запретить ставить сотрудника в другие кабинеты в расписании"
                v-model="isForbidSelectOtherCabinetsInSchedule" />
            </template>
          </div>

          <div
            class="employee-creation__contact__indent"
            v-if="!isAdmin && isEnabledWorkingScheduling"
          >
            <div class="employee-creation__contact__row">
              <multiline-select
                v-bind:items="cabinetOptionList"
                v-bind:label="'Выберите кресло'"
                v-bind:hint="'Кресло по умолчанию нужно для удобства заполнения расписания. В графике работы вы можете в любой день указывать сотруднику другие кресла'"
                v-model="cabinetIds"
                class="employee-creation__multiline explanation" />
            </div>
            <p
              class="employee-creation__error-text"
              role="alert"
              v-bind:key="id"
              v-for="(text, id) in cabinetInputErrors"
            >{{ text }}</p>
          </div>
          <div
            class="employee-creation__step"
            v-if="!isAdmin && isEnabledWorkingScheduling"
          >
            <label class="employee-creation__step__label" for="duration-appointment">Шаг приёма:</label>
            <select
              class="employee-creation__step__input"
              id="duration-appointment"
              v-model="defaultTimeStepMinutes"
            >
              <option
                v-for="(option, index) in timeStepOptionList"
                v-bind:key="index"
                v-bind:value="option.value"
              >{{ option.title }}</option>
            </select>
          </div>
          <div class="employee-creation__description" v-if="isEnabledWorkingScheduling">
            <label
              class="employee-creation__group"
              v-bind:class="{ field_error: infoInputErrors.length > 0 }"
            >
              <textarea
                class="employee-creation__textarea"
                placeholder="Информация о сотруднике"
                v-model="info"
                maxlength="100"
                rows="2"
                v-letter-capital
              />
              <p
                class="field__error-text"
                role="alert"
                v-bind:key="id"
                v-for="(text, id) in infoInputErrors"
              >{{ text }}</p>
            </label>
          </div>

          <div class="employee-creation__checkboxes">
            <template v-if="!isDismissed">
              <input-checkbox
                v-if="isOpenLoginSettingsSection"
                title="Разрешить доступ к системе"
                v-model="isAllowedLogin" />
            </template>
            <input-checkbox
              v-bind:disabled="isBranch"
              v-if="!isOwner"
              title="Уволен"
              v-model="isDismissed" />
            <div class="employee-creation__date" v-if="isDismissed">
              <div class="employee-creation__date__label">Дата увольнения</div>
              <v-menu min-width="auto">
                <template v-slot:activator="{ on }">
                  <div>
                    <button
                      class="employee-creation__date__activator"
                      title="Сменить дату"
                      type="button"
                      v-on="on"> {{ dismissedDateText }}</button>
                    <p
                      class="employee-creation__error-text"
                      role="alert"
                      v-bind:key="id"
                      v-for="(text, id) in dismissedDateInputErrors"
                    >{{ text }}</p>
                  </div>
                </template>
                <v-date-picker
                  color="#0489E0"
                  locale="ru-ru"
                  no-title
                  v-bind:allowed-dates="allowedDates"
                  v-model="dismissedDate"
                />
              </v-menu>
            </div>
          </div>
          <template v-if="isAllowedLogin && !isDismissed && isOpenLoginSettingsSection">
            <div class="employee-creation__mail">
              <label
                class="employee-creation__group"
                v-bind:class="{ field_error: emailAddressInputErrors.length > 0 }"
              >
                <span class="employee-creation__label">E-mail</span>
                <input
                  autocomplete="off"
                  class="employee-creation__input"
                  placeholder=""
                  type="email"
                  v-model="emailAddress" />
                <p
                  class="employee-creation__error-text"
                  role="alert"
                  v-bind:key="id"
                  v-for="(text, id) in emailAddressInputErrors"
                >{{ text }}</p>
              </label>
              <button
                class="employee-creation__button-password"
                type="button"
                v-on:click="onChangePassword"
              >
                Сменить пароль
              </button>
            </div>
          </template>
        </div>
      </template>
    </collapse-button>
    <collapse-button caption="Права">
      <template>
        <v-expansion-panels style="flex-direction: column">
          <div class="employee-creation__collapse">
            <template v-for="(group, key) in permissions">
              <div
                v-bind:key="key"
                v-if="group.withoutGroup"
              >
                <permission-item
                  class="employee-permission__form__permission"
                  v-for="permission in group.permissions"
                  v-bind:key="`${permission.id}-${permission.value}`"
                  v-bind:is-contains="permission.isContains"
                  v-bind:name="permission.name"
                  v-model="permission.value" />
              </div>
              <v-expansion-panel
                v-bind:key="key"
                v-else
              >
                <v-expansion-panel-header>
                  <div>{{group.name}}</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="employee-permission__form__group">
                    <permission-item
                      class="employee-permission__form__permission"
                      v-for="permission in group.permissions"
                      v-bind:key="`${permission.id}-${permission.value}`"
                      v-bind:is-contains="permission.isContains"
                      v-bind:name="permission.name"
                      v-model="permission.value" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </template>
          </div>
        </v-expansion-panels>
      </template>
    </collapse-button>
    <collapse-button
      caption="ЕГИСЗ"
      v-bind:value="isOpenEgisSection || !this.isEdit"
      v-if="allowedEgisz"
      v-on:input="onCollapseEgisSection"
    >
      <div class="employee-creation__collapse not-indent">
        <multiline-select
          class="employee-creation__multiline top"
          label="Специальность"
          type-of-autocomplete
          v-bind:violations="specialtyInputErrors"
          v-bind:items="employeeSpecialtyOptionList"
          v-model="specialtyIds"
        />
        <input-snils
          v-if='false'
          v-bind:violations="snilsInputErrors"
          v-model="snils" />
        <input-iin
          v-bind:violations="iinInputErrors"
          v-model="iin" />
        <the-select
          title="Выберите уровень конфиденциальности"
          v-bind:optional="false"
          v-bind:options="confidentialityLevelList"
          v-bind:violations="confidentialityLevelErrors"
          v-model="confidentialityLevelId"
        />
        <multiline-select
          class="employee-creation__multiline top"
          label="Должность"
          type-of-autocomplete
          v-bind:violations="nsiPositionInputErrors"
          v-bind:items="nsiPositionList"
          v-model="nsiPositionIds"
        />
      </div>
    </collapse-button>
    <slot name="footer" />
  </form>
</template>
<script>
import CollapseButton from '@/components/CollapseButton.vue';
import InputCheckbox from '@/components/InputCheckbox.vue';
import InputDate from '@/components/InputDate.vue';
import InputInn from '@/components/InputInn.vue';
import InputPhone from '@/components/InputPhone.vue';
import InputIin from '@/components/InputIin.vue';
import MultilineSelect from '@/components/MultilineSelect.vue';
import formMeaningfulFieldsMixin from '@/mixins/formMeaningfulFieldsMixin';
import {
  EditEmployeePermissionListRequest,
  EmployeeCreationRequest,
  EmployeeEditRequest,
} from '@/storage/gateways/EmployeeGateway';
import dateMixin, { getISODateStringByDate } from '@/mixins/dateMixin';
import PermissionItem from '@/components/PermissionItem.vue';
import TheSelect from '@/components/TheSelect.vue';
import { builtInDialogMixin, DialogResult } from '@/components/ClinicPanelDialog.vue';
import InputSnils from '@/components/InputSnils.vue';

/**
 * @description Название события создания сотрудника.
 * @type {string}
 */
const NAME_EVENT_SUBMIT_CREATING = 'submit-creating';

/**
 * @description Название события редактирования сотрудника.
 * @type {string}
 */
const NAME_EVENT_SUBMIT_EDITING = 'submit-editing';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * @description Получить снилс без разделителей.
 * @param {string} value
 * @returns {string}
 */
const getSnilsWithoutDelimiter = (value) => value.replace(/[-\s]/g, '');

/**
 * @description Компонент формы создания сотрудника.
 * @type {Vue}
 */
export default {
  components: {
    InputSnils,
    TheSelect,
    PermissionItem,
    CollapseButton,
    MultilineSelect,
    InputCheckbox,
    InputDate,
    InputInn,
    InputPhone,
    InputIin,
  },
  tooltipText: 'Кабинет по умолчанию нужен для удобства заполнения расписания. В графике работы вы можете в любой день указывать сотруднику другие кабинеты.',
  computed: {
    allowedEgisz() {
      return this.hasEgisz && (
        this.isAdmin !== true && /^\d+$/.test(this.roleId) !== true
      );
    },
    birthDateISO: ({ birthDate, formatDateToISO }) => formatDateToISO(birthDate),
    /**
     * @description Дата увольнения сотрудника.
     * @type {string}
     */
    dismissedDateText() {
      if (this.dismissedDate) {
        return this.getFullDate(this.dismissedDate);
      }
      return 'Укажите дату';
    },
    /**
     * @description Является ли сотрудник администратором.
     * @return {boolean}
     */
    isAdmin() {
      return this.roleId === 'admin';
    },
    /**
     * @description Является ли сотрудник врачом.
     * @return {boolean}
     */
    isDoctor() {
      return this.roleId === 'doctor';
    },
    /**
     * @description Форма открыта для редактирования.
     * @returns {boolean}
     */
    isEdit() {
      return this.initialId !== null;
    },
    birthDateInputErrors: resolveInputErrors('birth-date'),
    cabinetInputErrors: resolveInputErrors('cabinet-id'),
    confidentialityLevelErrors: resolveInputErrors('confidentiality-level'),
    dismissedDateInputErrors: resolveInputErrors('dismissed-date'),
    emailAddressInputErrors: resolveInputErrors('email'),
    roleIdInputErrors: resolveInputErrors('employee-role'),
    infoInputErrors: resolveInputErrors('info'),
    innInputErrors: resolveInputErrors('inn'),
    nameInputErrors: resolveInputErrors('name'),
    nsiPositionInputErrors: resolveInputErrors('nsi-position'),
    patronymicInputErrors: resolveInputErrors('patronymic'),
    phoneNumberInputErrors: resolveInputErrors('phone'),
    iinInputErrors: resolveInputErrors('iin'),
    snilsInputErrors: resolveInputErrors('snils'),
    specialtyInputErrors: resolveInputErrors('specialty-ids'),
    surnameInputErrors: resolveInputErrors('surname'),
    /**
     * @description Значимые поля.
     * @type {any}
     */
    meaningfulFields: (vm) => ({
      birthDate: vm.birthDate,
      cabinetIds: vm.cabinetIds,
      confidentialityLevelId: vm.confidentialityLevelId,
      defaultTimeStepMinutes: vm.defaultTimeStepMinutes,
      dismissedDate: vm.dismissedDate,
      emailAddress: vm.emailAddress,
      roleId: vm.roleId,
      isForbidSelectOtherCabinetsInSchedule: vm.isForbidSelectOtherCabinetsInSchedule,
      hasTelegramByPhone: vm.hasTelegramByPhone,
      hasWhatsappByPhone: vm.hasWhatsappByPhone,
      info: vm.info,
      inn: vm.inn,
      isAllowedCashbox: vm.isAllowedCashbox,
      isAllowedLogin: vm.isAllowedLogin,
      isEnabledWorkingScheduling: vm.isEnabledWorkingScheduling,
      isSendCredentialsMessage: vm.isSendCredentialsMessage,
      isDismissed: vm.isDismissed,
      name: vm.name,
      nsiPositionIds: vm.nsiPositionIds,
      patronymic: vm.patronymic,
      phoneNumber: vm.phoneNumber,
      iin: vm.iin,
      snils: vm.snils,
      specialtyIds: vm.specialtyIds,
      specialtyName: vm.specialtyName,
      surname: vm.surname,
    }),
  },
  data() {
    return {
      birthDate: this.initialBirthDate,
      cabinetIds: this.initialCabinetIds,
      confidentialityLevelId: this.initialConfidentialityLevelId,
      defaultTimeStepMinutes: this.initialTimeStepMinutes,
      dismissedDate: this.initialDismissedDate,
      emailAddress: this.initialEmail,
      hasTelegramByPhone: this.initialHasTelegramByPhone,
      hasUser: this.initialHasUser,
      hasWhatsappByPhone: this.initialHasWhatsAppByPhone,
      info: this.initialInfo,
      inn: this.initialInn,
      isAllowedCashbox: this.initialIsAllowedCashbox,
      isAllowedLogin: this.initialIsAllowedLogin,
      isDismissed: this.initialIsDismissed,
      isEnabledWorkingScheduling: this.initialIsEnabledWorkingScheduling,
      isForbidSelectOtherCabinetsInSchedule: this.initialIsForbidSelectOtherCabinetsInSchedule,
      isSendCredentialsMessage: false,
      name: this.initialName,
      nsiPositionIds: this.initialNsiPositionIds,
      patronymic: this.initialPatronymic,
      permissions: this.initialPermissions,
      phoneNumber: this.initialPhone,
      roleId: this.initialRoleId,
      iin: this.initialIin,
      snils: this.initialSnils,
      specialtyIds: this.initialSpecialtyIds,
      specialtyName: this.initialSpecialtyName,
      surname: this.initialSurname,
      isClearWorkScheduleConfirmed: false,
    };
  },
  currentDate: getISODateStringByDate(new Date()),
  methods: {
    /**
     * @description Функция описывающая условие доступности выбора дат в datepicker
     * @param {string} candidate Строка с датой в формате Y-m-d
     * @return {boolean}
     */
    allowedDates(candidate) {
      return candidate <= this.$options.currentDate;
    },
    /**
     * @description Отправить событие отправки создания сотрудника.
     * @returns {void}
     */
    dispatchSubmitCreation() {
      const request = this.makeEmployeeCreationRequest();
      this.$emit(NAME_EVENT_SUBMIT_CREATING, request);
    },
    /**
     * @description Отправить событие отправки редактирования сотрудника.
     * @returns {void}
     */
    dispatchSubmitEditing() {
      const request = this.makeEmployeeEditingRequest();
      this.$emit(NAME_EVENT_SUBMIT_EDITING, request);
    },
    /**
     * @description Создать запрос на создание сотрудника.
     * @returns {EmployeeCreationRequest}
     */
    makeEmployeeCreationRequest() {
      const [additionalPermissions, excludedPermissions] = this
        .permissions
        .flatMap(({ permissions }) => permissions)
        .reduce(
          ([additionalAcc, excludedAcc], { id, value }) => [
            [...additionalAcc, ...(value === 'additional' ? [id] : [])],
            [...excludedAcc, ...(value === 'excluded' ? [id] : [])],
          ],
          [[], []],
        );
      return new EmployeeCreationRequest(
        additionalPermissions,
        this.birthDateISO,
        this.cabinetIds,
        this.confidentialityLevelId,
        this.dismissedDate,
        this.emailAddress,
        excludedPermissions,
        this.roleId,
        this.hasTelegramByPhone,
        this.hasWhatsappByPhone,
        this.info,
        this.inn,
        this.isAllowedCashbox,
        this.isAllowedLogin,
        this.isDismissed,
        this.isEnabledWorkingScheduling,
        this.isForbidSelectOtherCabinetsInSchedule,
        this.name,
        this.hasEgisz,
        this.nsiPositionIds,
        this.isSendCredentialsMessage,
        this.patronymic,
        this.phoneNumber,
        this.iin,
        getSnilsWithoutDelimiter(this.snils),
        this.specialtyIds,
        this.specialtyName,
        this.surname,
        this.defaultTimeStepMinutes,
      );
    },
    /**
     * @description Создать запрос на редактирование.
     * @returns {EmployeeEditRequest}
     */
    makeEmployeeEditingRequest() {
      const additional = [];
      const excluded = [];
      const getIds = (permissions, value) => permissions
        .filter((candidate) => candidate.value === value)
        .map((permission) => permission.id);
      this.permissions.forEach((group) => {
        additional.push(...getIds(group.permissions, 'additional'));
        excluded.push(...getIds(group.permissions, 'excluded'));
      });
      const request = new EditEmployeePermissionListRequest(
        this.initialId,
        additional,
        excluded,
      );
      return new EmployeeEditRequest(
        this.birthDateISO,
        this.cabinetIds,
        this.confidentialityLevelId,
        this.dismissedDate,
        this.emailAddress,
        this.roleId,
        this.hasTelegramByPhone,
        this.hasWhatsappByPhone,
        this.initialId,
        this.info,
        this.inn,
        this.isAllowedCashbox,
        this.isAllowedLogin,
        this.isDismissed,
        this.isEnabledWorkingScheduling,
        this.isForbidSelectOtherCabinetsInSchedule,
        this.name,
        this.hasEgisz,
        this.nsiPositionIds,
        this.patronymic,
        this.phoneNumber,
        this.iin,
        getSnilsWithoutDelimiter(this.snils),
        this.specialtyIds,
        this.specialtyName,
        this.surname,
        this.defaultTimeStepMinutes,
        request,
      );
    },
    /**
     * @description Обработать событие изменения пароля.
     */
    onChangePassword() {
      this.$emit('change-password', this.initialId);
    },
    /**
     * @description Обработать переключение видимости секции "Дополнительно".
     * @type {boolean} isOpen
     * @returns {void}
     */
    onCollapseOptionalSection(isOpen) {
      this.$emit('collapse-optional-section', isOpen);
    },
    /**
     * @description Обработать переключение видимости секции "Егисз".
     * @type {boolean} isOpen
     * @returns {void}
     */
    onCollapseEgisSection(isOpen) {
      this.$emit('collapse-egis-section', isOpen);
    },
    /**
     * @description Нужно показать диалог об удалении смен на будущее.
     * @param {string} newRoleId
     * @returns {boolean}
     */
    needShowClearWorkScheduleDialog(newRoleId) {
      if (this.isClearWorkScheduleConfirmed) {
        return false;
      }
      if (newRoleId === this.initialRoleId) {
        return false;
      }
      return ['admin', 'doctor'].includes(this.initialRoleId);
    },
    /**
     * @description Обработать изменение роли.
     * @type {string} roleId Идентификатор роли.
     * @returns {void}
     */
    async onInputRole(roleId) {
      const prevRoleId = this.roleId;
      this.roleId = roleId;
      if (this.needShowClearWorkScheduleDialog(roleId)) {
        let dialogTitle = 'График работы будет очищен. Изменить роль?';
        const initialRole = this.employeeRoleList.find(({ value }) => value === this.initialRoleId);
        if (initialRole) {
          dialogTitle = `График работы для роли "${initialRole.title}" будет очищен. Изменить роль?`;
        }
        const dialog = await this.showDialog(dialogTitle, DialogResult.CANCEL, DialogResult.CHANGE);
        if (dialog.result !== DialogResult.CHANGE) {
          this.roleId = prevRoleId;
          return;
        }
        this.isClearWorkScheduleConfirmed = true;
      }
      const { defaultPermissions } = this
        .employeeRoleList
        .find((candidate) => candidate.value === roleId);
      const mapPosition = (candidate) => ({
        ...candidate,
        value: 'by-positions',
        isContains: defaultPermissions.includes(candidate.id),
      });
      this.permissions = this
        .permissions
        .map((group) => ({ ...group, permissions: group.permissions.map(mapPosition) }));
    },
    /**
     * @description Обработать сохранение формы.
     * @returns {void}
     */
    onSubmit() {
      if (this.isEdit) {
        this.dispatchSubmitEditing();
      } else {
        this.dispatchSubmitCreation();
      }
    },
  },
  mixins: [
    builtInDialogMixin,
    dateMixin,
    formMeaningfulFieldsMixin,
  ],
  props: {
    /**
     * @description Кабинеты.
     * @type {{title: string, value: string}[]}
     */
    cabinetOptionList: {
      required: true,
      type: Array,
    },
    /**
     * @description Уровни конфиденциальности.
     * @type {{title: string, value: string}[]}
     */
    confidentialityLevelList: {
      required: true,
      type: Array,
    },
    /**
     * @description Должности сотрудников.
     * @type {{title: string, value: string}[]}
     */
    employeeRoleList: {
      required: true,
      type: Array,
    },
    /**
     * @description Специальности сотрудников.
     * @type {{title: string, value: string}[]}
     */
    employeeSpecialtyOptionList: {
      required: true,
      type: Array,
    },
    /**
     * @description Клиника имеет ЕГИСЗ.
     * @type {boolean}
     */
    hasEgisz: {
      required: true,
      type: Boolean,
    },
    initialBirthDate: {
      default: () => '',
      type: String,
    },
    initialCabinetIds: {
      default: () => [],
      type: Array,
    },
    initialConfidentialityLevelId: {
      default: () => '',
      type: String,
    },
    initialDismissedDate: {
      default: () => '',
      type: String,
    },
    initialEmail: {
      default: () => '',
      type: String,
    },
    initialHasTelegramByPhone: {
      default: () => false,
      type: Boolean,
    },
    initialHasUser: {
      default: () => false,
      type: Boolean,
    },
    initialHasWhatsAppByPhone: {
      default: () => false,
      type: Boolean,
    },
    initialId: {
      default: () => null,
      type: Number,
    },
    initialInfo: {
      default: () => '',
      type: String,
    },
    initialInn: {
      default: () => '',
      type: String,
    },
    initialIsAllowedCashbox: {
      default: () => false,
      type: Boolean,
    },
    initialIsAllowedLogin: {
      default: () => false,
      type: Boolean,
    },
    initialIsDismissed: {
      default: () => false,
      type: Boolean,
    },
    initialIsEnabledWorkingScheduling: {
      default: () => true,
      type: Boolean,
    },
    initialIsForbidSelectOtherCabinetsInSchedule: {
      default: () => false,
      type: Boolean,
    },
    initialName: {
      default: () => '',
      type: String,
    },
    /**
     * @description Идентификаторы исходных должностей по ЕГИСЗ НСИ.
     */
    initialNsiPositionIds: {
      default: () => [],
      type: Array,
    },
    initialPatronymic: {
      default: () => '',
      type: String,
    },
    /**
     * @description Разрешения
     * @type {(object[])}
     */
    initialPermissions: {
      required: true,
      type: Array,
    },
    initialPhone: {
      default: () => '',
      type: String,
    },
    initialPositionIds: {
      default: () => [],
      type: Array,
    },
    initialRoleId: {
      default: () => '',
      type: String,
    },
    initialIin: {
      default: () => '',
      type: String,
    },
    initialSnils: {
      default: () => '',
      type: String,
    },
    initialSpecialtyIds: {
      default: () => [],
      type: Array,
    },
    initialSpecialtyName: {
      default: () => '',
      type: String,
    },
    initialSurname: {
      default: () => '',
      type: String,
    },
    initialTimeStepMinutes: {
      default: () => 30,
      type: Number,
    },
    /**
     * @description Ошибки ввода.
     * @type {any}
     */
    inputErrors: {
      default: () => ({}),
      type: Object,
    },
    /**
     * @description Сотрудник филиальный.
     * @type {boolean}
     */
    isBranch: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description Секция "Дополнительно" открыта.
     * @type {boolean}
     */
    isOpenOptionalSection: {
      required: true,
      type: Boolean,
    },
    /**
     * @description Секция "Разрешить доступ к системе" открыта.
     * @type {boolean}
     */
    isOpenLoginSettingsSection: {
      required: false,
      type: Boolean,
      default: () => true,
    },
    /**
     * @description Секция "ЕГИСЗ" открыта.
     * @type {boolean}
     */
    isOpenEgisSection: {
      required: true,
      type: Boolean,
    },
    isOwner: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description Должности по ЕГИСЗ НСИ.
     * @type {{title: string, value: string}[]}
     */
    nsiPositionList: {
      required: true,
      type: Array,
    },
    /**
     * @description Ячейки времени приема.
     * @type {{title: string, value: string}[]}
     */
    timeStepOptionList: {
      required: true,
      type: Array,
    },
  },
};
</script>
<style lang="scss">
@use "@/scss/buttons";

.employee-creation {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 34px;
  margin: 47px 0 0 0;
  &__date {
    &__label {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #90A0B7;
      margin: 0 0 3px 0;
    }
    &__activator {
      padding: 10px 50px 10px 10px;
      border: 1px solid #C2CFE0;
      border-radius: 4px;
      font-size: 16px;
      background-image: url("@/assets/img/calendar-grey.svg");
      background-position: right 10px center;
    }
  }
  &__status-title {
    color: #90a0b7;
  }
  &__row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
  }
  &__group {
    display: flex;
    flex-direction: column;
    &.field_error {
      .employee-creation__label {
        color: var(--warning-color);
      }
    }
  }
  &__label {
    color: #90A0B7;
    opacity: 0.7;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }
  &__multiline {
    flex: 1;
    &.explanation {
      .multiline-select__row:first-child {
        .multiline-select__placeholder {
          cursor: pointer !important;
          pointer-events: auto;
          &:after {
            content: "?";
            font-size: 13px;
            margin: 0 0 0 5px;
          }
        }
      }
    }
    .multiline-select__row {
      grid-template-columns: 2fr minmax(88px, 0.4fr);
    }
    &.top {
      margin-top: 37px;
    }
  }
  &__input {
    background: #ffffff;
    border: 1px solid #c2cfe0;
    border-radius: 4px;
    outline: none;
    height: 40px;
    width: 100%;
    padding: 0 10px;
    appearance: none;
    font-size: 16px;
    color: #192a3e;
    font-weight: 400;
    &:focus {
      color: #192a3e;
      background-color: #fff;
      border: 2px solid #0489e0;
      outline: 0;
    }
    &:disabled {
      background-color: #fff;
    }
  }
  &__error-text {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 12px;
    padding: 0;
    margin: 5px 0 0 0;
    background-color: transparent!important;
  }
  &__contacts {
    display: grid;
    grid-template-columns: 0.97fr 2fr;
    align-items: flex-start;
    grid-gap: 10px;
  }
  &__contact {
    display: flex;
    align-items: center;
    background-color: #eef2f8;
    border-radius: 4px;
    padding: 8px;
    cursor: pointer;
    &__row {
      margin: 17.5px 0 0 0;
    }
    &.whats-app {
      margin: 0 10px 0 0;
    }
    &:before {
      content: "";
      width: 24px;
      height: 24px;
      background-repeat: no-repeat;
      background-size: contain;
      margin: 0 10px 0 0;
    }
    &.whats-app:before {
      background-image: url("@/assets/img/social/whats-app-grey.svg");
    }
    &.telegram:before {
      background-image: url("@/assets/img/social/telegram-grey.svg");
    }
    &__row {
      display: flex;
      flex-direction: row;
      position: relative;
    }
    &__text {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      background-color: white;
      color: rgba(0,0,0,.87);
      padding: 5px;
      border-radius: 5px;
      box-shadow: 0 0 20px rgba(54, 77, 92, 0.18);
      max-width: 250px;
      font-size: 12px;
    }
    &__indent {
      margin: 15px 0 0 0;
      .multiline-select {
        grid-gap: 33px;
      }
    }
  }
  &__cabinet,
  &__step {
    display: grid;
    align-items: center;
    &__label {
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      color: #192a3e;
      margin: 0 23px 0 0;
    }
    &__input {
      background-color: #ffffff;
      background-image: url("@/assets/img/checked/checked-grey.svg");
      background-position: right 17px center;
      border: 1px solid #c2cfe0;
      border-radius: 4px;
      outline: none;
      height: 40px;
      padding: 0 10px;
      appearance: none;
      font-size: 16px;
      color: #192a3e;
      font-weight: 400;
      &.validate {
        border-color: var(--warning-color);
      }
      &:focus {
        color: #192a3e;
        background-color: #fff;
        border: 2px solid #0489e0;
        outline: 0;
        background-image: url("@/assets/img/checked/checked-grey-top.svg");
      }
      &:disabled {
        background-color: #fff;
        background-image: url("@/assets/img/checked/checked-grey.svg");
      }
    }
  }
  &__cabinet {
    grid-template-columns: 10rem 1fr;
    width: 70%;
  }
  &__step {
    grid-template-columns: 120px 1fr;
    width: 45%;
  }
  &__textarea {
    background: #ffffff;
    border: 1px solid #c2cfe0;
    border-radius: 4px;
    z-index: 2;
    outline: none;
    -webkit-appearance: none;
    width: 100%;
    padding: 10px;
    appearance: none;
    font-size: 16px;
    color: #626262;
    font-weight: 400;
    margin: 0 0 2px 0;
    &:focus {
      background-color: #fff;
      border: 2px solid #0489e0;
      margin: 0;
    }
  }
  &__description {
    width: 100%;
  }
  &__checkboxes {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px;
  }
  &__mail {
    display: grid;
    grid-template-columns: 1fr minmax(150px, 174px);
    align-items: end;
    gap: 15px 20px;
  }
  &__button-password {
    @include buttons.btn-blue(100%, 40px, 16px);
    max-width: 174px;
    &:disabled {
      background-color: var(--unfocus-color);
    }
  }
  &__password {
    position: relative;
    & > .employee-creation__input {
      padding-right: 40px;
    }
    &__toggle {
      background-image: url("@/assets/img/eye-closed.svg");
      background-position: center;
      height: 40px;
      position: absolute;
      right: 0;
      top: 0;
      width: 40px;
      &.active {
        background-image: url("@/assets/img/eye-open.svg");
      }
      cursor: pointer;
    }
  }
  &__specialty {
    & .v-list-item__title {
      white-space: normal;
    }
  }
  &__collapse {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 0;
    &.indent {
      margin: 20px 0 0 0;
    }
    .v-expansion-panel:first-child {
      margin: 20px 0 0 0;
    }
    .v-expansion-panel:before {
      box-shadow: none;
    }
    .v-expansion-panel-header {
      padding: 0;
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      color: #192a3e;
      min-height: 25px;
    }
    .v-expansion-panel:not(:first-child):after {
      border-top: none;
    }
    .v-expansion-panel-content__wrap {
      padding: 0;
    }
    .v-expansion-panel-content {
      margin: 15px 0 0 0;
    }
  }
}
.employee-creation__contact > input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.employee-creation__contact > span {
  display: inline-flex;
  align-items: center;
  user-select: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
}

.employee-creation__contact > span::after {
  content: "";
  display: inline-block;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  flex-grow: 0;
  border: 1px solid #90a0b7;
  border-radius: 4px;
  margin: 0 0 0 10px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 70%;
  background-color: #ffffff;
}
.employee-creation__contact > input:not(:disabled):not(:checked) + span:hover::after {
  border-color: #0489e0;
}
.employee-creation__contact > input:checked:focus + span::after {
  border-color: var(--focus-input-color) !important;
}
.employee-creation__contact > input:not(:disabled):active + span::after {
  background-color: #90a0b7;
  border-color: #90a0b7;
}
.employee-creation__contact > input:focus:not(:checked) + span::after {
  border-color: #0489e0;
}
.employee-creation__contact > input:checked + span::after {
  background-color: #0489e0;
  border-color: #0489e0;
  background-image: url("@/assets/img/checked/checked-white-top.svg");
}

.employee-creation__checkbox > input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.employee-creation__checkbox > span {
  display: inline-flex;
  align-items: center;
  user-select: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
}

.employee-creation__checkbox > span::before {
  content: "";
  display: inline-block;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  flex-grow: 0;
  border: 1px solid #90a0b7;
  border-radius: 4px;
  margin: 0 10px 0 0;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 70%;
  background-color: #ffffff;
}
.employee-creation__checkbox > input:checked:focus + span::before {
  border-color: var(--focus-input-color) !important;
}
.employee-creation__checkbox > input:not(:disabled):not(:checked) + span:hover::before {
  border-color: #0489e0;
}
.employee-creation__checkbox > input:not(:disabled):active + span::before {
  background-color: #90a0b7;
  border-color: #90a0b7;
}
.employee-creation__checkbox > input:focus:not(:checked) + span::before {
  border-color: #0489e0;
}
.employee-creation__checkbox > input:checked + span::before {
  background-color: #0489e0;
  border-color: #0489e0;
  background-image: url("@/assets/img/checked/checked-white-top.svg");
}
@media screen and (max-width: 920px) {
  .employee-creation {
    &__step {
      width: 60%;
    }
  }
}
@media screen and (max-width: 520px) {
  .employee-creation {
    &__row {
      grid-template-columns: 1fr;
    }
    &__mail {
      grid-template-columns: 1fr;
    }
    &__step {
      width: 100%;
    }
    &__contacts {
      grid-template-columns: 1fr;
      &.align {
        align-items: center;
        .employee-creation__contact__row {
          margin: 0 0 0 0;
        }
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .employee-creation {
    &__contact {
      width: max-content;
      &.whats-app {
        margin: 0 0 10px 0;
      }
      &__row {
        flex-direction: column;
      }
    }
  }
}

.employee-permission {
  display: flex;
  flex-direction: row;
  width: 100%;
  &__button {
    @include buttons.btn-blue(100%, 48px, 16px);
    @include buttons.btn-blue-add(19px);
    max-width: 300px;
  }
  &__body {
    padding: 38px 20px 48px 23px;
    width: 100%;
    overflow-y: scroll;
    &__row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-content: center;
      gap: 10px;
    }
  }
  &-table {
    counter-reset: counterEmployees;
    margin: 25px 0 0 0;
    &__head,
    &__row {
      width: 100%;
      text-align: left;
      align-items: center;
      cursor: pointer;
      display: grid;
      font-size: 14px;
      grid-template-columns: 40px 1fr 1fr 47px;
      line-height: 17px;
    }
    &__head {
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
      padding: 10px 0;
    }
    &__row {
      border-bottom: 1px solid #eaeff3;
      padding: 12px 0;
      &:hover {
        background: #eaeff3;
      }
    }
    &__cell {
      padding: 0 8px;
      &.number:after {
        counter-increment: counterEmployees;
        content: counter(counterEmployees);
      }
    }
    &__icon {
      &-edit {
        background-image: url("@/assets/img/pen-grey.svg");
        background-size: contain;
        background-repeat: no-repeat;
        width: 14px;
        height: 14px;
        padding: 0;
        margin: 0;
        cursor: pointer;
        &:hover {
          background-image: url("@/assets/img/pen-blue.svg");
        }
      }
    }
  }
  &__form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    &__employee-name {
      margin-top: 15px;
      font-size: 22px;
      font-weight: bold;
    }
    &__group {
      display: flex;
      flex-direction: column;
      gap: 5px;
      cursor: default;
    }
    &__permission {
      margin-left: 15px;
    }
    &__buttons {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 10px;
      max-width: 438px;
      width: 100%;
      margin: 54px 0 0 auto;
    }
    &__button {
      &-cancel {
        @include buttons.btn-transparent(100%, 56px, 20px);
      }
      &-submit {
        @include buttons.btn-blue(100%, 56px, 20px);
      }
    }
  }
}
</style>
